
export default {
    namespaced: true,

    state: {
        id    : null,
        name  : '',
        email : '',
        avatar: '',
    },

    getters: {
        isLoggedIn(user) {
            return user.id != null;
        }
    },

    mutations: {
        setUser(user, data) {
            user.id = data.id;
            user.name = data.name;
            user.email = data.email;
            user.avatar = data.avatar;
        },
    },

    actions: {

    },


}
